import React from 'react';

const AlertBadge = ({ 
  type = 'info', 
  count = 0, 
  title, 
  description, 
  onClick,
  icon,
  pulse = false 
}) => {
  const typeStyles = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-800',
      badge: 'bg-green-500 text-white',
      icon: 'text-green-600'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      text: 'text-yellow-800',
      badge: 'bg-yellow-500 text-white',
      icon: 'text-yellow-600'
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      text: 'text-red-800',
      badge: 'bg-red-500 text-white',
      icon: 'text-red-600'
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-800',
      badge: 'bg-blue-500 text-white',
      icon: 'text-blue-600'
    },
    neutral: {
      bg: 'bg-gray-50',
      border: 'border-gray-200',
      text: 'text-gray-800',
      badge: 'bg-gray-500 text-white',
      icon: 'text-gray-600'
    }
  };

  const styles = typeStyles[type] || typeStyles.info;

  return (
    <div 
      className={`
        ${styles.bg} ${styles.border} 
        border rounded-lg p-4 
        ${onClick ? 'cursor-pointer hover:shadow-md transform hover:-translate-y-0.5' : ''} 
        transition-all duration-200 relative
        ${pulse ? 'animate-pulse' : ''}
      `}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3 flex-1">
          {icon && (
            <div className={`text-xl ${styles.icon} mt-0.5`}>
              {icon}
            </div>
          )}
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-2">
              <h4 className={`font-medium ${styles.text} truncate`}>
                {title}
              </h4>
              
              {count > 0 && (
                <span className={`
                  ${styles.badge} 
                  text-xs font-bold px-2 py-1 rounded-full 
                  ${pulse ? 'animate-bounce' : ''}
                `}>
                  {count}
                </span>
              )}
            </div>
            
            {description && (
              <p className="text-sm text-gray-600 mt-1">
                {description}
              </p>
            )}
          </div>
        </div>
        
        {onClick && (
          <div className={`text-sm ${styles.text} ml-2`}>
            →
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertBadge;